import { request } from './api';

/**
 * L'aperçu de rôle, et l'en-tête qui le porte — pour TOUS les modules RH.
 *
 * Ce fichier existe parce que l'oubli était invisible : l'en-tête ne vivait que
 * dans le client des notes de frais. Les routes congés, écrites plus tard avec
 * le `request` générique, ne l'envoyaient donc jamais — et le serveur, qui n'a
 * rien à honorer sans en-tête, répondait avec la session réelle. En aperçu, on
 * lisait ses PROPRES soldes en croyant lire ceux de la personne endossée, et un
 * congé était refusé pour un chevauchement qui n'était pas le sien.
 *
 * Il n'y a donc plus qu'UNE résolution : tout client de module RH passe par
 * `requeteRh`. En ajouter un nouveau sans y penser reproduirait exactement le
 * même bug, en silence.
 */

let apercuSalarieId: string | null = null;

export function definirApercu(id: string | null) {
  apercuSalarieId = id;
}

export function apercuActif(): string | null {
  return apercuSalarieId;
}

/** L'en-tête d'aperçu, quand il est actif. Vide sinon. */
export function entetesApercu(): Record<string, string> {
  return apercuSalarieId ? { 'X-Ndf-Apercu': apercuSalarieId } : {};
}

/**
 * Un appel de module RH : notes de frais, congés, et ce qui viendra.
 *
 * Le serveur n'honore l'en-tête que pour un administrateur, et refuse toute
 * écriture en aperçu hors pré-production. L'envoyer systématiquement ne relâche
 * donc rien : c'est le serveur qui décide, ici on ne fait que le lui dire.
 */
export function requeteRh<T>(chemin: string, init?: RequestInit): Promise<T> {
  if (!apercuSalarieId) return request<T>(chemin, init);
  return request<T>(chemin, {
    ...init,
    headers: { ...(init?.headers ?? {}), ...entetesApercu() },
  });
}
